import { Component, OnInit ,NgZone,Input} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from 'src/app/services/theme.service';
import { SBICARDTheme } from 'src/app/config/app-settings.config';
import cssVars from "css-vars-ponyfill";
import { getDeviceSize } from 'src/app/utilities/utilities.file';

@Component({
  selector: 'app-track-app-home',
  templateUrl: './track-app-home.component.html',
  styleUrls: ['./track-app-home.component.scss']
})
export class TrackAppHomeComponent implements OnInit {
 showTrackPage: any =false;
 showRetrievePage: any =false;
 textColorChange = true;
  themeParam: any;
  responseTheme: any;
  themeObj: any;
  authDetails: any;
  @Input() heading :any;
  isMobile: boolean;
  isactiveButtonTrack:boolean =true;
  isactiveButtonRetrieve:boolean =false;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  constructor(
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    // (document.documentElement || document.body).scrollTop = 0;
    document.getElementById('sbicard')?document.getElementById('sbicard').scrollTop=0:(document.documentElement || document.body).scrollTop = 0;
    this.containerType = sessionStorage.getItem('container-type');
    this.route.queryParams.subscribe(query => {
      if(query){
        const theme = query.theme;
        // this.setThemeByParam(theme);
      }
    });
    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    }
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    };
    if(this.isMobile) {
      this.showTrackPage = true;
      this.isactiveButtonTrack =true;
    }
    this.authDetails = window['authenticationDetails'] ? window['authenticationDetails'].EapplyTokenGenerationResponse.tokenGenerationResponse : '';
    if (this.authDetails) {
      sessionStorage.setItem('jwt', this.authDetails.access_token);
      sessionStorage.setItem('encryptedToken', this.authDetails.encrypted_token);
      document.cookie = this.authDetails['x-sbic-user-fgp'].split(';')[0] + ';Path=/';
    }
  }

  showTrackView() {
    this.showTrackPage = true;
    this.showRetrievePage = false;
    this.textColorChange = true;
    this.isactiveButtonTrack =true;
    this.isactiveButtonRetrieve =false;
  }


  showRetrieveView() {
  this.showRetrievePage = true;
  this.showTrackPage = false;
  this.textColorChange = false;
  this.isactiveButtonTrack =false;
  this.isactiveButtonRetrieve =true;
 
  }

  setThemeByParam(theme) {
    this.themeParam = theme;
    console.log(this.themeParam);
    this.getThemeFromService(theme);
    this.themeService.themeParam = this.themeParam;
  }

  getThemeFromService(theme) {
    this.themeService.getThemeData(theme).subscribe((result: any) => {
      if (result) {
        if (result.partner_id && result.partner_id === theme) {
          this.responseTheme = result;
          this.themeObj = this.responseTheme;
          this.themeService.setThemePage(this.themeObj);
          cssVars({ variables: this.themeObj });//Theme change for IE 
        } else {
          // this.errorMsg = 'JSON not found';
          this.themeService.setThemePage(SBICARDTheme);
          cssVars({ variables: SBICARDTheme });//Theme change for IE 
        }
      } else {
        // this.errorMsg = 'JSON error';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({ variables: SBICARDTheme });//Theme change for IE 
      }
    },
      (error) => {
        // this.errorMsg = 'Service not available';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({ variables: SBICARDTheme });//Theme change for IE 
      }
    );
  }
}
